import React, { memo, useMemo, useState } from 'react'
import { Link } from '@material-ui/core'
import * as Styled from './styled'
import {
  DENTAL_SERVICES,
  fullOrthodontic
} from '../../shared/constants/dentalServices'
import useModal from '../../hooks/useModal'
import CustomLivesFormDialog from '../CustomLivesFormDialog'
import useBreakpoints from '../../hooks/useBreakpoints'
import ProceduresListModal from '../ProceduresListModal'

const PlanProceduresList = ({
  code,
  hasOrthodontics,
  complete,
  size,
  listStyle,
  allProcedures,
}) => {
  const { isOpen, closeModal, openModal } = useModal()
  const { isDesk } = useBreakpoints()

  const dentalProceduresList = useMemo(
    () =>
      hasOrthodontics ? [fullOrthodontic, ...DENTAL_SERVICES] : DENTAL_SERVICES,
    [hasOrthodontics]
  )

  const [modalProceduresOpened, setModalProceduresOpened] = useState(false)

  return (
    <>
      <Styled.PrecedureList size={size} complete={complete} style={listStyle}>
        {dentalProceduresList.map(({ name }) => (
          <li key={name}>
            {' '}
            <Styled.ListMarker>● {'  '}</Styled.ListMarker> {name}
          </li>
        ))}
      </Styled.PrecedureList>

      <Styled.AllProcedures style={allProcedures}>
        <strong>+ 90 procedimentos</strong>
        <Link
          component='button'
          variant='caption'
          onClick={() => {setModalProceduresOpened(true)}}
          underline='always'
          style={{ marginLeft: '10px', color: '#0091ff' }}
        >
          Ver todos
          </Link>
      </Styled.AllProcedures>
      <CustomLivesFormDialog
        onCancel={closeModal}
        open={isOpen}
        isDesk={isDesk}
      />

      <ProceduresListModal
        isDesk={isDesk}
        onCancel={() => {setModalProceduresOpened(false)}}
        open={modalProceduresOpened}
        planCode={code}
      />

    </>
  )
}
export default memo(PlanProceduresList)  